export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_21.ae7de861.jpg";